module.exports = __webpack_public_path__ + "static/media/Icons_play.fff07c05.svg";